










import { Vue, Component } from 'vue-property-decorator';
import InventarioSimBase from './InventarioSimBase.vue';

@Component({
  components: { InventarioSimBase },
})
export default class ReportesInventarioSim extends Vue {}
